export const GET_LAWS = 'GET_LAWS'
export const SET_LAWS = 'SET_LAWS'
export const GET_LAWS_ERROR = 'GET_LAWS_ERROR'
export const RESET_LAWS = 'RESET_LAWS'
export const SET_LAW_FILTERS = 'SET_LAW_FILTERS'
export const RESET_LAW_FILTERS = 'RESET_LAW_FILTERS'
